import { Injectable, NgZone } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';

// Each check only downloads and hashes a small manifest file (ngsw.json), not
// the app itself — 10 min is still cheap and catches a deploy faster for
// users who leave a tab open for a long time.
const CHECK_INTERVAL_MS = 10 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  constructor(
    private swUpdate: SwUpdate,
    private dialogService: DialogService,
    private ngZone: NgZone,
  ) {}

  initialize(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(
        filter(
          (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY',
        ),
      )
      .subscribe(() => this.promptReload());

    // The app shell itself failed to load correctly (corrupted cache, etc.)
    // — nothing to ask the user, just recover.
    this.swUpdate.unrecoverable.subscribe(() => {
      window.location.reload();
    });

    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.swUpdate.checkForUpdate().catch(() => {});
      }, CHECK_INTERVAL_MS);
    });
  }

  private promptReload(): void {
    this.ngZone.run(() => {
      const ref = this.dialogService.open(ConfirmationModalComponent, {
        showHeader: false,
        width: '450px',
        contentStyle: { padding: '0', borderRadius: '8px' },
        data: {
          title: 'Nova versão disponível',
          message:
            'Uma nova versão do sistema foi publicada. Atualize agora para continuar recebendo as últimas correções.',
          confirmLabel: 'Atualizar agora',
          confirmIcon: 'pi pi-refresh',
          cancelLabel: 'Depois',
        },
      });

      ref.onClose.subscribe((confirmed: boolean) => {
        if (confirmed) {
          window.location.reload();
        }
      });
    });
  }
}
